
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 15l.005-.217A5 5 0 0113 15h2l-.004-.24A6.995 6.995 0 0011.25 8.8a5 5 0 10-6.5-.001A6.999 6.999 0 001 15h2zm5-7a3 3 0 110-6 3 3 0 010 6zm.002 11A3.998 3.998 0 0012 15a4 4 0 10-3.998 4zm0-1a3 3 0 11-.004-6 3 3 0 01.004 6zm-.006-1c.132.002.26-.05.353-.144a.474.474 0 00.146-.353v-1.02l1.006.02a.503.503 0 00.353-.146.504.504 0 00-.357-.857H8.49v-.996A.504.504 0 007.986 13a.475.475 0 00-.335.144.484.484 0 00-.146.358l.018.995h-1.02a.504.504 0 00-.357.857c.094.093.22.146.352.146l1.02-.02-.018 1.023a.474.474 0 00.146.353.483.483 0 00.35.144z","fill-rule":"nonzero"}})])
          )
        }
      }
    